import * as MODULE from '../modules';
import * as ROUTES from './Routes';

const sistemaRouteMap = {
  [ROUTES.root.to]: MODULE.PanelRoot,
  [ROUTES.usuarios.to]: MODULE.Usuarios,
  [ROUTES.entidades.to]: MODULE.Entidades,
  [ROUTES.panelEntidad.to]: MODULE.PanelEntidad,
  [ROUTES.carreras.to]: MODULE.Carreras,
  [ROUTES.modulos.to]: MODULE.Modulos,
  [ROUTES.system.to]: MODULE.System,
  [ROUTES.monedas.to]: MODULE.Monedas,
  [ROUTES.vistas.to]: MODULE.Vistas,
  [ROUTES.deportes.to]: MODULE.Deportes,
  [ROUTES.suscripciones.to]: MODULE.Suscripciones,
  [ROUTES.pagosSuscripcion.to]: MODULE.PagosSuscripcion,
  [ROUTES.operadoras.to]: MODULE.Operadoras,
  [ROUTES.nivelesAcademicos.to]: MODULE.NivelesAcademicos,
  [ROUTES.perfiles.to]: MODULE.Perfiles,
  [ROUTES.profesiones.to]: MODULE.Profesiones,
  [ROUTES.tiposActividadesExtraCur.to]: MODULE.TiposActividadesExtcur,
  [ROUTES.carnetOnEdu.to]: MODULE.Carnet,
  [ROUTES.impresionCarnet.to]: MODULE.ImpresionCarnet,
};

const entidadRouteMap = {
  [ROUTES.controlEstudios.to]: MODULE.PanelControlEstudios,
  [ROUTES.boletines.to]: MODULE.Boletines,
  [ROUTES.boletinesPdf.to]: MODULE.BoletinesPdf,
  [ROUTES.bloquesPedagogicos.to]: MODULE.BloquesPedagogicos,
  [ROUTES.panelBloquePedagogico.to]: MODULE.PanelBloquePedagogico,
  [ROUTES.secciones.to]: MODULE.Secciones,
  [ROUTES.aulario.to]: MODULE.Aulario,
  [ROUTES.planEvaluacion.to]: MODULE.PlanEvaluacion,
  [ROUTES.panelPlanEvaluacion.to]: MODULE.PanelPlanEvaluacion,
  [ROUTES.horarios.to]: MODULE.Horarios,
  [ROUTES.panelHorarios.to]: MODULE.PanelHorarios,
  [ROUTES.entHorarioClasesAjustes.to]: MODULE.AjustesEntHorarioClases,
  [ROUTES.matriculas.to]: MODULE.Matriculas,
  [ROUTES.panelMatriculas.to]: MODULE.PanelMatriculas,
  [ROUTES.estudiantes.to]: MODULE.Estudiantes,
  [ROUTES.estudiantesDocentes.to]: MODULE.EstudiantesDocente,
  [ROUTES.panelEstudiantes.to]: MODULE.PanelEstudiantes,
  [ROUTES.familiares.to]: MODULE.Familiares,
  [ROUTES.panelFamiliares.to]: MODULE.PanelFamiliares,
  [ROUTES.familiaresPdf.to]: MODULE.FamiliaresPdf,
  [ROUTES.docentes.to]: MODULE.Docentes,
  [ROUTES.panelDocentes.to]: MODULE.PanelDocentes,
  [ROUTES.periodosAcademicos.to]: MODULE.PeriodosAcademicos,
  [ROUTES.entNivelesAcademicos.to]: MODULE.EntNivelesAcademicos,
  [ROUTES.materias.to]: MODULE.Materias,
  [ROUTES.asistenciasDiarias.to]: MODULE.Asistencias,
  [ROUTES.entCarreras.to]: MODULE.EntCarreras,
  [ROUTES.accesos.to]: MODULE.Accesos,
  [ROUTES.eventos.to]: MODULE.Eventos,
  [ROUTES.usuEntidades.to]: MODULE.UsuEntidades,
  [ROUTES.panelUsuEntidades.to]: MODULE.PanelUsuarios,
  [ROUTES.usuEntPerfiles.to]: MODULE.UsuEntPerfiles,
  [ROUTES.permisos.to]: MODULE.Permisos,
  [ROUTES.notas.to]: MODULE.PanelNotas,
  [ROUTES.notasEvaluativas.to]: MODULE.NotasEvaluativas,
  [ROUTES.notasBloped.to]: MODULE.NotasBloped,
  [ROUTES.panelAdministracion.to]: MODULE.PanelAdministracion,
  [ROUTES.reportes.to]: MODULE.Reportes,
  [ROUTES.resumenes.to]: MODULE.Resumenes,
  [ROUTES.verificador.to]: MODULE.Verificador,
  [ROUTES.misEntidades.to]: MODULE.MisEntidades,
  [ROUTES.actividadesExtras.to]: MODULE.ActividadesExtras,
  [ROUTES.panelActividadExtra.to]: MODULE.PanelActividadExtra,
};

const recibosRouteMap = {
  [ROUTES.recibos.to]: MODULE.Recibos,
  [ROUTES.recibosPdf.to]: MODULE.RecibosPdf,
  [ROUTES.conceptos.to]: MODULE.Conceptos,
};

const docentesRouteMap = {
  [ROUTES.herramientas.to]: MODULE.Herramientas,
  [ROUTES.academico.to]: MODULE.PanelAcademico,
  [ROUTES.temasAcademicos.to]: MODULE.TemasAcademicos,
  [ROUTES.evaluaciones.to]: MODULE.Evaluaciones,
  [ROUTES.actividadesAcademicas.to]: MODULE.ActividadesAcademicas,
  [ROUTES.materiasDocentes.to]: MODULE.MateriasDocentes,
  [ROUTES.tablero.to]: MODULE.Tablero,
  [ROUTES.ajustes.to]: MODULE.EntAjustes,
};

const juegosDeportivosRouteMap = {
  [ROUTES.torneos.to]: MODULE.Torneos,
  [ROUTES.panelTorneos.to]: MODULE.PanelTorneos,
  [ROUTES.equipos.to]: MODULE.Equipos,
  [ROUTES.panelEquipos.to]: MODULE.PanelEquipos,
  [ROUTES.juegos.to]: MODULE.Juegos,
  [ROUTES.jugadores.to]: MODULE.Jugadores,
  [ROUTES.panelJuegos.to]: MODULE.PanelJuegos,
  [ROUTES.resultados.to]: MODULE.Resultados,
};

export const routesMap = {
  ...sistemaRouteMap,
  ...entidadRouteMap,
  ...recibosRouteMap,
  ...docentesRouteMap,
  ...juegosDeportivosRouteMap,
};
